import { Yii } from "libraries/interfaces/Yii";

export class IdentityInfoEditorWording {
    public readonly identityCard: string = Yii.t('wui-shared-js', "Carte d'identité :");
    public readonly passport: string = Yii.t('wui-shared-js', "Passeport :");
    public readonly frequentTravellerCard: string = Yii.t('wui-shared-js', "Carte de fidélité :");
    public readonly validityEnd: string = Yii.t('wui-shared-js', "Date d'expiration :");
    public readonly nationality: string = Yii.t('wui-shared-js', "Nationalité :");
    public readonly shortIdentityCard: string = Yii.t('wui-shared-js', "CNI");
    public readonly shortPassport: string = Yii.t('wui-shared-js', "Passeport");
    public readonly shortSfpd: string = Yii.t('wui-shared-js', "SFPD");
    public readonly birthDate: string = Yii.t('wui-shared-js', "Date de naissance :");
    public readonly passportNumber: string = Yii.t('wui-shared-js', "Numéro de passeport :");
    public readonly identityPlaceOfIssue: string = Yii.t('wui-shared-js', "Pays d'émission :");
    public readonly gender: string = Yii.t('wui-shared-js', "Sexe :");
    public readonly identityCardNumber: string = Yii.t('wui-shared-js', "Numéro de carte d'identité :");
    public readonly noIdentityInfo: string = Yii.t('wui-shared-js', "Aucune pièce d'identité");
}
